var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Widget',{staticClass:"mb-xlg",attrs:{"bodyClass":"mt","id":"izin-prov-chart","title":`<div class='row'>
       <div class='col-sm-12 col-xs-12 text-center'>
         <h5>
         PNBP (${_vm.getYear.yPast}-${_vm.getYear.yNow})
         </h5>
       </div>
       <div class='col-xs-4 col-sm-4'>
         <div class='chart-legend' />
       </div>
     </div>`,"customHeader":"","collapse":"","close":""}},[_c('apexchart',{key:_vm.testKey,attrs:{"type":"bar","height":"520","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }